import baseConfig from 'onyx-app-pe/config/config.base'

const config = {
  ...baseConfig,
  theme: 'Stup',
  storeKey: 'onyx-app-pe-stup'
}

export default config
